import { SVGProps } from 'react'

export const ProfileAvatarsLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="137rem"
      height="1rem"
      viewBox="0 0 137 1"
      fill="none"
      {...props}
    >
      <path d="M2.90082e-06 0.5H137" stroke="url(#paint0_radial_3433_18602)" />
      <defs>
        <radialGradient
          id="paint0_radial_3433_18602"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(137.531 -15.8096) rotate(180) scale(137.531 3927.63)"
        >
          <stop stopColor="#7F7F7F" />
          <stop offset="1" stopColor="#7F7F7F" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}
